import { Select } from "antd";
import { useState } from "react";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import countries from "../data/countries.json";
import { getListTemplates } from "../utils/APIs";
import { getLanguage } from "../utils/Utils";

const { Option } = Select;
const language = getLanguage();

export const CountrySelect = ({ setCountry, style }) => {
  const [templates, setTemplates] = useState([]);
  useEffect(() => {
    getListTemplates().then((res) => {
      setTemplates(res);
    });
  }, []);
  const getCountryName = (country) => {
    return language == "fr" ? country.title_fr : country.title_en;
  };
  const changeCountry = (e) => {
    setCountry({
      id: e,
      name: getCountryName(countries.filter((c) => c.id == e)[0]),
    });
  };
  return (
    <div style={style}>
      <span className="roi--label-section">
        <FormattedMessage id="countrySelected" />
      </span>
      <Select
        showSearch
        className="roi--select-text"
        style={{ width: 400 }}
        placeholder="Search to Select"
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={(e) => changeCountry(e)}
        filterSort={(optionA, optionB) =>
          optionA.children
            .toLowerCase()
            .localeCompare(optionB.children.toLowerCase())
        }
      >
        {countries.map((country, i) => (
          <Option value={country.id}>
            {getCountryName(country) +
              " (" +
              templates.filter((a) => a.country_id == country.id).length +
              " template)"}
          </Option>
        ))}
      </Select>
    </div>
  );
};
